/* eslint-disable no-void */

import { FunctionComponent } from 'react';

import Homepage from './Homepage';

type FC = FunctionComponent;

const HomepageContainer: FC = () => <Homepage />;

export default HomepageContainer;
